import create from 'zustand';

export interface PostState {
  PostId: string;
  shouldRefetch: boolean;
}

export const usePost = create<PostState>(() => ({
  PostId: '',
  shouldRefetch: false,
}));

export default usePost;
